import React from 'react'
import Modal from '../../elements/ModalBlue'
import Button from '../../elements/Button'

import { Wrapper, Title, Text, WrapperButton } from './styles'

import image from '../../../static/icon-veloe-background.svg'

class AddTagsModal extends React.Component {
  render() {
    const { handleClick } = this.props
    return (
      <Modal backgroundImage={image} position="right bottom">
        <Wrapper>
          <Title>Sua VeloeTag foi bloqueada</Title>
          <Text>
            Por enquanto, você não vai conseguir ter acesso livre aos locais conveniados, mas fique
            tranquilo. Você pode pedir uma nova VeloeTag para curtir o que realmente importa.
          </Text>

          <WrapperButton>
            <Button buttonType="darkBlue" text="Ok" onClick={() => handleClick()} />
          </WrapperButton>
        </Wrapper>
      </Modal>
    )
  }
}

export default AddTagsModal



// WEBPACK FOOTER //
// ./src/app/modules/BlockModal/index.js